import types from './types';

const defaultState = {};

export default (state = defaultState, { type, data, ...action }) => {
	switch (type) {
		case types.GET_VERSION:
			return { ...state, isLoading: true };
		case types.GET_VERSION_SUCCESS:
			return { ...state, version: data, isLoading: false };
		case types.GET_VERSION_FAILURE:
			return { ...state, isLoading: false };

		default:
			return state;
	}
};
